var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconShield48Line = function SvgIconShield48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 39.71c-.43 0-.86-.1-1.26-.29-2.8-1.34-11.94-6.57-11.94-17.51v-5.29c0-2.22 1.4-4.22 3.49-4.98l8.72-3.17c.64-.23 1.34-.23 1.98 0l8.72 3.16c2.09.76 3.49 2.76 3.49 4.98v5.29c0 10.94-9.14 16.17-11.95 17.51-.4.19-.83.29-1.25.29v.01Zm-8.55-24.87c-.75.27-1.25.99-1.25 1.79v5.29c0 8.69 7.23 13.06 9.8 14.34 2.57-1.28 9.8-5.64 9.8-14.34v-5.29c0-.8-.5-1.51-1.25-1.79L24 11.74l-8.55 3.1Z",
    fill: "current"
  })));
};
export default SvgIconShield48Line;